import React from 'react'
import { injectIntl } from 'react-intl'

import { dateStringToYmdHM } from '../../services/DateStringFormat'

import Icon from '../../components/common/icon/Icon'
import DataTable from '../../components/common/dataTable/DataTable'
import DataTableHeader from '../../components/common/dataTable/DataTableHeader'
import DataTableHeaderCol from '../../components/common/dataTable/DataTableHeaderCol'
import DataTableRow from '../../components/common/dataTable/DataTableRow'
import DataTableCol from '../../components/common/dataTable/DataTableCol'

import Pager from '../../components/common/pager/Pager'

import TruncateAndTooltip from '../../components/common/truncateAndTooltip/TruncateAndTooltip'
import SingleLoader from '../../components/common/singleLoader/SingleLoader'
import MessageFeedback from '../../components/common/messageFeedback/MessageFeedback'

function formatTimeZone (tz) {
  return tz.split('.')[0]
}

const AggregateReportMessages = ({
  intl, error, loading, items, pageNumber, pageSize, totalItems, onChangePager, onReload,
  loadingNext,
  loadingPrev,
  pagerDisabled
}) => {
  function renderItem (item) {
    return (
      <DataTableRow key={item.IdMessage}>
        <DataTableCol width='1'>{item.IdList}</DataTableCol>
        <DataTableCol width='5' wrapperEl='div' wrapperClassName='frontend-p-right-thin'>
          {item.error && <Icon family='fa' icon='exclamation-triangle' className='text-light' tooltipText={intl.formatMessage({ id: 'Load.Common.LoadDataError' })} />}
          {!item.error && !item.Subject && <p className='is-loading' />}
          {!item.error && item.Subject && <TruncateAndTooltip wrapperEl='strong' text={item.Subject} />}
          <p className='frontend-note'>ID {item.IdMessage}</p>
        </DataTableCol>
        <DataTableCol width='2' wrapperEl=''>
          <p>{dateStringToYmdHM(item.LastSentJs.StringValue)}</p>
          <p className='frontend-note'>{formatTimeZone(item.TimeZone)}</p>
        </DataTableCol>
        <DataTableCol width='1' className='frontend-text-right' wrapperEl=''><p><strong>{intl.formatNumber(item.Recipients)}</strong></p></DataTableCol>
        <DataTableCol width='1' wrapperEl='div' className='frontend-text-right'>
          <p><strong>{intl.formatNumber(item.Delivered)}</strong></p>
          <p className='frontend-note'>{intl.formatNumber(item.SuccessfulDeliveriesRate / 100, { style: 'percent', maximumFractionDigits: 2 })}</p>
        </DataTableCol>
        <DataTableCol width='1' wrapperEl='div' className='frontend-text-right'>
          <p><strong>{intl.formatNumber(item.Opens)}</strong></p>
          <p className='frontend-note'>{intl.formatNumber(item.OpenRate / 100, { style: 'percent', maximumFractionDigits: 2 })}</p>
        </DataTableCol>
        <DataTableCol width='1' wrapperEl='div' className='frontend-text-right'>
          <p><strong>{intl.formatNumber(item.Clicks)}</strong></p>
          <p className='frontend-note'>{intl.formatNumber(item.ClickRate / 100, { style: 'percent', maximumFractionDigits: 2 })}</p>
        </DataTableCol>
      </DataTableRow>
    )
  }

  const pagerProps = {
    currentPage: pageNumber,
    itemsPerPage: pageSize,
    totalItems: totalItems,
    onChange: onChangePager,
    ofLabel: intl.formatMessage({ id: 'Load.Pager.Of' }),
    itemsLabel: intl.formatMessage({ id: 'Load.Pager.Items' }),
    loadingNext,
    loadingPrev,
    disabled: pagerDisabled
  }

  const loaderProps = {
    height: '300px'
  }

  return (
    <div className='frontend-row frontend-box'>
      <h2 className='frontend-m-bottom-x-sm'>{intl.formatMessage({ id: 'Load.Statistics.AggregateMessagesList' })}</h2>

      <section>
        <DataTable>
          <DataTableHeader>
            <DataTableHeaderCol width='1'>{intl.formatMessage({ id: 'Load.MailupCommon.List' })}</DataTableHeaderCol>
            <DataTableHeaderCol width='5'>{intl.formatMessage({ id: 'Load.MailupCommon.Message' })}</DataTableHeaderCol>
            <DataTableHeaderCol width='2'>{intl.formatMessage({ id: 'Load.MailupCommon.LastSend' })}</DataTableHeaderCol>
            <DataTableHeaderCol width='1' className='frontend-text-right'>{intl.formatMessage({ id: 'Load.MailupCommon.Recipients' })}</DataTableHeaderCol>
            <DataTableHeaderCol width='1' className='frontend-text-right'>{intl.formatMessage({ id: 'Load.MailupCommon.Delivered' })}</DataTableHeaderCol>
            <DataTableHeaderCol width='1' className='frontend-text-right'>{intl.formatMessage({ id: 'Load.MailupCommon.Open' })}</DataTableHeaderCol>
            <DataTableHeaderCol width='1' className='frontend-text-right'>{intl.formatMessage({ id: 'Load.MailupCommon.Click' })}</DataTableHeaderCol>
          </DataTableHeader>

          {error &&
            <DataTableRow className='no-border frontend-m-bottom-sm'>

              <Icon family='fa' icon='exclamation-triangle' className='text-light' />&nbsp;
              <span>{intl.formatMessage({ id: 'Load.Common.LoadDataError' })}</span>

            </DataTableRow>}

          {!error && loading && <SingleLoader {...loaderProps} />}

          {!error && !loading && items.map((item, index) => renderItem(item, index))}

        </DataTable>

        {!error && <Pager {...pagerProps} />}

      </section>

    </div>
  )
}

export default injectIntl(AggregateReportMessages)
